import { render } from "./WebDesign.vue?vue&type=template&id=79455bc1"
import script from "./WebDesign.vue?vue&type=script&lang=js"
export * from "./WebDesign.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__